import { render, staticRenderFns } from "./supplyModel.vue?vue&type=template&id=23afc02f&scoped=true"
import script from "./supplyModel.vue?vue&type=script&lang=js"
export * from "./supplyModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afc02f",
  null
  
)

export default component.exports